import { query } from "./dom";

const elements = {
  canvas: () => query("#hero canvas"),
  image: () => query("#hero img"),
};

const containerMaxWidth = 1170;

export const setup = () => {
  const viewportWidth = document.documentElement.clientWidth;
  if (viewportWidth <= containerMaxWidth) return;

  const canvas = elements.canvas();
  const image = elements.image();
  if (!canvas || !image) return;

  const ctx = canvas.getContext("2d");
  const draw = () => {
    const imageWidth = containerMaxWidth;
    const imageHeight = 780;
    canvas.height = imageHeight;
    canvas.width = containerMaxWidth * 3;
    ctx.drawImage(image, imageWidth, 0, imageWidth, imageHeight);

    ctx.scale(-1, 1);
    ctx.drawImage(image, -imageWidth, 0, imageWidth, imageHeight);
    ctx.drawImage(image, -3 * imageWidth, 0, imageWidth, imageHeight);
    image.hidden = true;
  };

  if (image.complete) {
    draw();
  } else {
    image.addEventListener("load", draw);
  }
};
